import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { LocalStorageService } from '../_services/local-storage.service';
import { ReportsService } from '../_services/reports.service';
import { ExcelService } from '../_services/excel.service';
import { Router } from '@angular/router';
import * as moment from "moment";


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers: [ExcelService]

})
export class ReportsComponent implements OnInit {

  startDate: any = Date;
  endDate: any = Date;
  startDateAndEndDateForm: FormGroup;
  role: any
  selectedStartDate:any
  selectedEndDate:any
  teammemberRoute:any//boolean=false
  tabactive: string
  constructor(private formBuilder: FormBuilder, private datePipe: DatePipe, private localStorageService: LocalStorageService, private reportsService:ReportsService, private excel:ExcelService, private router: Router) { 
     // Check if there is data in local storage
    //  const storedStartDate = localStorage.getItem('startDate');
    //  const storedEndDate = localStorage.getItem('endDate');

    //  console.log(storedEndDate, 'storedEndDatestoredEndDate')

 
    //  if (storedStartDate && storedEndDate) {
    //    this.startDate = new Date(storedStartDate);

    //    this.endDate = new Date(storedEndDate);

    //    console.log(this.startDate, 'ddddddddddddd')

    //  } else {
    //    // If there is no data in local storage, set the dates to the last 7 days
    //    const today = new Date();
    //    this.endDate = today; // End date is today
    //    const sevenDaysAgo = new Date(today);
    //    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Start date is 7 days ago
    //    this.startDate = sevenDaysAgo;
 
    //    // Save the initial dates to local storage
    //    localStorage.setItem('startDate', this.startDate.toISOString());
    //    localStorage.setItem('endDate', this.endDate.toISOString());

    //    const formattedStartDate = this.datePipe.transform(this.startDate, 'dd-MMM-yyyy');
    //    const formattedEndDate = this.datePipe.transform(this.endDate, 'dd-MMM-yyyy');
    //    this.selectedStartDate =  formattedStartDate
    //    this.selectedEndDate = formattedEndDate
    //  }

    //     // Initialize the FormGroup and add form controls with validators
    //     this.startDateAndEndDateForm = this.formBuilder.group({
    //       startDate: [this.startDate],
    //       endDate: [this.endDate]
    //     });
    
    //     // Set up the form control with custom validation
    //     this.startDateAndEndDateForm.setValidators(this.dateRangeValidator());
      


    // Check if there is data in local storage
    const storedStartDate = localStorage.getItem('startDate');
    const storedEndDate = localStorage.getItem('endDate');


    if (storedStartDate && storedEndDate) {
      this.startDate = new Date(storedStartDate);
      this.endDate = new Date(storedEndDate);

    } else {
      // If there is no data in local storage, set the dates to the last 7 days
      // const today = new Date();
      // this.endDate = today; // End date is today
      // const sevenDaysAgo = new Date(today);
      // sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // Start date is 7 days ago
      // this.startDate = sevenDaysAgo;

      this.endDate = moment().format('YYYY-MM-DD');
      this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');

      // Save the initial dates to local storage
      localStorage.setItem('startDate', this.startDate);
      localStorage.setItem('endDate', this.endDate);

      // Set selectedStartDate and selectedEndDate
      // this.selectedStartDate = this.formatDateToYYYYMMDD(this.startDate);
      // this.selectedEndDate = this.formatDateToYYYYMMDD(this.endDate);
    }

    // Initialize the FormGroup and add form controls with validators
    this.startDateAndEndDateForm = this.formBuilder.group({
      startDate: [this.startDate],
      endDate: [this.endDate]
    });

    // Set up the form control with custom validation
    this.startDateAndEndDateForm.setValidators(this.dateRangeValidator());
    

  }

  ngOnInit(): void {
    this.tabactive = this.router.url.split('/')[2]
    this.role = this.localStorageService.getItem('role')
     if(this.tabactive === '/reports/team-members'){
      this.tabactive = 'team-members'
      this.localStorageService.setItem('tabname', this.tabactive)
     }

    this.teammemberRoute = this.localStorageService.getItem('tabname')
    this.formatDate();
  }
  onTabChange(type) {
    if(type == 'team-members') {
      this.tabactive = 'team-members'
      this.router.navigateByUrl('/reports/team-members')
      this.localStorageService.setItem('tabname', this.tabactive)
      this.teammemberRoute = this.localStorageService.getItem('tabname')
     
    } else if(type == 'personal-reports') {
      this.tabactive = 'personal-reports'
      this.localStorageService.setItem('tabname', this.tabactive)
      this.router.navigate(['/reports/personal-reports'])
      this.teammemberRoute = this.localStorageService.getItem('tabname')

    }
  }
  saveDates() {
    document.getElementById("dropdown-reports").classList.remove("show");

    // Save the start and end dates to local storage

    const formattedStartDate = this.datePipe.transform(this.startDate, 'yyyy-MM-dd');
    const formattedEndDate = this.datePipe.transform(this.endDate, 'yyyy-MM-dd');
  

    const formattedStartDateForUI = this.datePipe.transform(this.startDate, 'dd-MMM-yyyy');
    const formattedEndDateForUI = this.datePipe.transform(this.endDate, 'dd-MMM-yyyy');
    this.selectedStartDate =  formattedStartDateForUI
    this.selectedEndDate = formattedEndDateForUI

    
    localStorage.setItem('startDate', formattedStartDate);
    localStorage.setItem('endDate', formattedEndDate);

    this.startDateAndEndDateForm.updateValueAndValidity();

    
    this.reportsService.createDataWithDate();

  }


  dateRangeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
    
      if (this.startDate > this.endDate) {
        return { dateRangeError: true };
      }

      return null;
    };
  }


  formatDate(){
    
    const formattedStartDateForUI = this.datePipe.transform(this.startDate, 'dd-MMM-yyyy');
    const formattedEndDateForUI = this.datePipe.transform(this.endDate, 'dd-MMM-yyyy');
    this.selectedStartDate =  formattedStartDateForUI
    this.selectedEndDate = formattedEndDateForUI


  }

   formatDateToYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  onStartDateChange() {
    const startDate = this.startDateAndEndDateForm.get('startDate').value;
    const endDate = this.startDateAndEndDateForm.get('endDate').value;
  
    if (moment(this.startDate, 'YYYY-MM-DD').isAfter(moment(this.endDate, 'YYYY-MM-DD'))) {
      this.startDateAndEndDateForm.setErrors({ dateRangeError: true });
    } else {
      if (this.startDateAndEndDateForm.hasError('dateRangeError')) {
        this.startDateAndEndDateForm.setErrors(null); // Clear the 'dateRangeError' error
      }
    }
  }
  
  onEndDateChange() {
    const startDate = this.startDateAndEndDateForm.get('startDate').value;
    const endDate = this.startDateAndEndDateForm.get('endDate').value;
  
    if (moment(this.startDate, 'YYYY-MM-DD').isAfter(moment(this.endDate, 'YYYY-MM-DD'))) {
      this.startDateAndEndDateForm.setErrors({ dateRangeError: true });
    } else {
      if (this.startDateAndEndDateForm.hasError('dateRangeError')) {
        this.startDateAndEndDateForm.setErrors(null); // Clear the 'dateRangeError' error
      }
    }
  }
  
  datePickerClosedStartDate(event: any) {
    this.onStartDateChange();

  }

  datePickerClosedEndDate(event: any) {
    this.onEndDateChange();

  }
  
  
  

}
